import React from "react";
import {
  WSElement,
  WSList,
  WSText,
  WSIcon
} from "@wingspanhq/fe-component-library";
import styles from "./ScopesList.module.scss";

interface ScopesListProps {
  /**
   * `resourceCategories` from the selected candidate. These are already
   * human-readable category names chosen for consent display, so there is no
   * scope-to-copy lookup table any more — the provider decides the wording.
   */
  resourceCategories: Set<string>;
}

export const ScopesList: React.FC<ScopesListProps> = ({
  resourceCategories
}) => {
  const categories = Array.from(resourceCategories ?? []);

  if (categories.length === 0) {
    return null;
  }

  return (
    <WSElement>
      <WSText.Paragraph mb="S" weight="medium">
        This application will be able to:
      </WSText.Paragraph>
      <WSList.Vertical>
        {categories.map(category => (
          <WSElement key={category} mb="XS" className={styles.scopeItem}>
            <WSIcon name="check-circle" size="M" color="green500" mr="S" />
            <WSText.Paragraph>{category}</WSText.Paragraph>
          </WSElement>
        ))}
      </WSList.Vertical>
    </WSElement>
  );
};
